<template>
  <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M128 128C128 92.7 156.7 64 192 64L448 64C483.3 64 512 92.7 512 128L512 554C512 572.6 491.8 584.1 475.8 574.7L320 482.6L164.2 574.6C148.2 584.1 128 572.6 128 554L128 128zM192 96C174.3 96 160 110.3 160 128L160 540L307.8 452.7C315.3 448.2 324.7 448.2 332.2 452.7L480 540L480 128C480 110.3 465.7 96 448 96L192 96z"
      fill="currentColor"
    />
  </svg>
</template>
